// @flow
import _ from 'underscore'

export type ParsedRole = {
  name: string[],
  purpose: string[],
  domain: string[],
  accountability: string[],
  ...
}

export default function legacyParseRoleText(string: string, fields: string[]): ParsedRole {
  const lines = (string || '').split('\n')
  const data = {}

  function getLine(field, regex, pickLastMatch = true) {
    const match = lines[0].match(regex)
    if (!match)
      return false

    const rawVal = pickLastMatch
      ? match[match.length - 1]
      : match[0]

    const val = rawVal.trim()

    if (val && val.length > 0 && _(fields).include(field)) {
      data[field] = data[field] || []
      data[field].push(val)
    }

    if (match) {
      lines.shift()
      return true
    }

    return false
  }

  function parseLines() {
    if (lines.length === 0)
      return null

    if (getLine('blank', /^\s*$/)
      || getLine('name', /^\s*(name|role):(.*)$/i)
      || getLine('purpose', /^\s*purpose:(.*)$/i)
      || getLine('domain', /^\s*domains?:(.*)$/i)
      || getLine('blank', /^[\W0-9]*accountabilit(y|ies):\s*$/i)
      || getLine('accountability', /^[\W0-9]*accountabilit(y|ies):\s*(\w.*)$/i)
      || getLine('accountability', /^[\W0-9]*(\w.*)$/i, false))
      return parseLines()

    throw new Error('parse error')
  }

  parseLines()
  return data
}
